/**
 * Utility functions for managing first-time guide state
 */

const FIRST_TIME_GUIDE_KEYS = {
  CREATE_FROM_SCRATCH: 'guide_auto_estimate_create_from_scratch',
  CREATE_FROM_DRAWING: 'guide_auto_estimate_create_from_drawing',
  CREATE_FROM_MEASUREMENT: 'guide_auto_estimate_create_from_measurement',
  CREATE_FROM_TEMPLATE: 'guide_auto_estimate_create_from_template',
} as const;

/**
 * Check if it's the first time for a given guide type
 */
export const isFirstTime = (
  guideType: keyof typeof FIRST_TIME_GUIDE_KEYS
): boolean => {
  const key = FIRST_TIME_GUIDE_KEYS[guideType];
  const value = localStorage.getItem(key);
  return value !== 'true';
};

/**
 * Mark a guide type as completed (no longer first time)
 */
export const markAsCompleted = (
  guideType: keyof typeof FIRST_TIME_GUIDE_KEYS
): void => {
  const key = FIRST_TIME_GUIDE_KEYS[guideType];
  localStorage.setItem(key, 'true');
};

/**
 * Reset a guide type (for testing purposes)
 */
export const resetGuide = (
  guideType: keyof typeof FIRST_TIME_GUIDE_KEYS
): void => {
  const key = FIRST_TIME_GUIDE_KEYS[guideType];
  localStorage.removeItem(key);
};

/**
 * Reset all guides (for testing purposes)
 */
export const resetAllGuides = (): void => {
  Object.values(FIRST_TIME_GUIDE_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
};
